"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WpsRequestImpl = void 0;
var request_abstract_1 = require("./request-abstract");
var WpsRequestImpl = /** @class */ (function (_super) {
    __extends(WpsRequestImpl, _super);
    function WpsRequestImpl() {
        return _super.call(this) || this;
    }
    WpsRequestImpl.prototype.request = function (params) {
        return new Promise(function (resolve, reject) {
            var _a, _b;
            try {
                var method = params.method, headers = params.headers, data = params.data, reset = __rest(params, ["method", "headers", "data"]);
                var _c = headers, contentType = _c.contentType, _resetHeader = __rest(_c, ["contentType"]);
                var options = __assign({ type: method, data: JSON.stringify(data), header: Object.assign({}, _resetHeader), contentType: contentType }, reset);
                // @ts-ignore
                (_b = (_a = window.Extention) === null || _a === void 0 ? void 0 : _a.Network) === null || _b === void 0 ? void 0 : _b.httpRequest(options, function (result) {
                    result = JSON.parse(result);
                    if (result.code && !(result === null || result === void 0 ? void 0 : result.error_code)) {
                        try {
                            var response = JSON.parse(result.result);
                            resolve(response);
                        }
                        catch (error) {
                            console.log('[ai sdk WpsRequestImpl request error] ', error);
                            // TODO：先兼容error 下 result里放错误返回，后续再看下能否优化
                            reject({
                                code: result.code || 0,
                                msg: result.error_message || result.result || '未知错误',
                                data: result.data || null
                            });
                        }
                        // TODO：兼容处理，后续梳理result情况，返回对象错误信息
                        // } else if (result.code && result?.error_code) {
                    }
                    else {
                        var errorResponse = {
                            data: result === null || result === void 0 ? void 0 : result.data,
                            code: (result === null || result === void 0 ? void 0 : result.error_code) || result.code,
                            msg: result === null || result === void 0 ? void 0 : result.error_message
                        };
                        reject(errorResponse);
                    }
                });
            }
            catch (error) {
                reject(error);
            }
        });
    };
    WpsRequestImpl.prototype.requestCancelable = function (params) {
        // TODO
        console.log('requestCancelable params**', params);
    };
    return WpsRequestImpl;
}(request_abstract_1.RequestAbstract));
exports.WpsRequestImpl = WpsRequestImpl;
exports.default = new WpsRequestImpl();
